import React, { useEffect } from 'react';
import {
    setMobileAction,
    setEmailAction,
    setNameAction,
    setBirthdateAction,
    setContactOption,
    setContactDateTimeOption,
    setContactTimeAction,
    setContactDateAction
} from '../store/actions';
import { TextField, PhoneField, EmailField, DateField } from 'migration-flos-react';
import {
    selectResources,
    selectName,
    selectBirthdate,
    selectEmail,
    selectMobile,
    selectIsNameValid,
    selectIsBirthdateValid,
    selectDisplayError,
    selectIsEmailValid,
    selectIsMobileValid,
    selectMinimal
} from '../store/selectors';
import { connect } from 'react-redux';
import AddressField from '../components/address-field';
import FieldWrapper from '../components/field-wrapper';

const Contact = ({
    resources,
    contactName,
    contactBirthdate,
    contactMobile,
    contactEmail,
    setName,
    setBirthdate,
    setMobile,
    setEmail,
    isNameValid,
    isBirthdateValid,
    showError,
    isEmailValid,
    isMobileValid,
    minimal,
    setOption,
    setContactDateTime
}) => {
    const { name, birthdate, mobile, email, title } = resources.section2;

    useEffect(() => {
        if (minimal) {
            setOption('PHONE');
            setContactDateTime('0');
        }
    }, [minimal, setOption, setContactDateTime]);

    return (
        <div className="container u-Space-down">
            <form id="Get-quote-contact-form">
                {!minimal && <h3>{title}</h3>}
                <FieldWrapper>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 row">
                        <TextField
                            id="name"
                            label={name.label}
                            value={contactName}
                            onChangeValue={setName}
                            status={isNameValid ? 'success' : contactName || showError ? 'error' : undefined}
                            helpText={(contactName || showError) && isNameValid === false && name.error}
                            required
                        />
                    </div>
                </FieldWrapper>
                <FieldWrapper>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 row">
                        <DateField
                            id="birthdate"
                            label={birthdate.label}
                            value={contactBirthdate}
                            onChangeValue={setBirthdate}
                            status={isBirthdateValid ? 'success' : contactBirthdate || showError ? 'error' : undefined}
                            helpText={(contactBirthdate || showError) && isBirthdateValid === false && birthdate.error}
                            required
                            minDate="01-01-1922"
                            maxDate="31-12-2012"
                        />
                    </div>
                </FieldWrapper>
                <FieldWrapper>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 row">
                        <AddressField />
                    </div>
                </FieldWrapper>
                <FieldWrapper>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 row">
                        <PhoneField
                            id="mobile"
                            label={mobile.label}
                            onChangeValue={setMobile}
                            value={contactMobile}
                            errorHelpText={mobile.error}
                            status={contactMobile ? (isMobileValid ? 'success' : 'error') : undefined}
                            required
                            maxLength={11}
                        />
                    </div>
                </FieldWrapper>
                <FieldWrapper>
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 row">
                        <EmailField
                            id="email"
                            label={email.label}
                            errorHelpText={email.error}
                            onChangeValue={setEmail}
                            value={contactEmail}
                            status={contactEmail ? (isEmailValid ? 'success' : 'error') : undefined}
                            required
                        />
                    </div>
                </FieldWrapper>
            </form>
        </div>
    );
};

const mapStates = (state) => ({
    resources: selectResources(state),
    contactName: selectName(state),
    contactBirthdate: selectBirthdate(state),
    contactEmail: selectEmail(state),
    contactMobile: selectMobile(state),
    isNameValid: selectIsNameValid(state),
    isBirthdateValid: selectIsBirthdateValid(state),
    showError: selectDisplayError(state),
    isEmailValid: selectIsEmailValid(state),
    isMobileValid: selectIsMobileValid(state),
    minimal: selectMinimal(state)
});

const mapDispatch = (dispatch) => ({
    setName: (name) => dispatch(setNameAction(name)),
    setBirthdate: (birthdate) => dispatch(setBirthdateAction(birthdate)),
    setEmail: (email) => dispatch(setEmailAction(email)),
    setMobile: (mobile) => dispatch(setMobileAction(mobile)),
    setOption: (option) => dispatch(setContactOption(option)),
    setContactDateTime: (dateTime) => {
        dispatch(setContactDateTimeOption(dateTime));
        dispatch(setContactTimeAction(''));
        dispatch(setContactDateAction(''));
    }
});

export default connect(mapStates, mapDispatch)(Contact);
